import {webkitLineClamp} from 'webkit-line-clamp';
import PageLoadedQueue
    from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/PageLoadedQueue";

class BlogPosts {

    constructor(post: HTMLElement) {

        const croppedLines = post.querySelectorAll('.croppedLines') as NodeListOf<HTMLElement>;
        Array.from(croppedLines).forEach((croppedLine) => {
            const lines = parseInt(croppedLine.dataset.linecrop, 10) ?? 1;
            webkitLineClamp(croppedLine, lines);
        });
    }

    static initializedElements: Map<HTMLElement, BlogPosts> = new Map();

    static initialize() {
        BlogPosts.checkElements();
        document.addEventListener('plandent.html.changed', (e) => {
            BlogPosts.checkElements();
        });
    }

    static checkElements() {

        document.querySelectorAll('.blog-posts').forEach((blogPost: HTMLFormElement) => {
            if (!BlogPosts.initializedElements.has(blogPost)) {
                BlogPosts.initializedElements.set(blogPost, new BlogPosts(blogPost));
            }
        });
    }
}

PageLoadedQueue.addFunction(BlogPosts.initialize);
